import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDownload, FiCheckCircle } = FiIcons;

const Danke = () => {
  return (
    <div className="pt-24 pb-16 min-h-screen bg-gray-50">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-8"
          >
            <SafeIcon icon={FiCheckCircle} className="text-6xl text-green-500 mx-auto mb-6" />
          </motion.div>

          <h1 className="text-4xl md:text-5xl font-bold text-black mb-8">
            Vielen Dank für deine Angaben
          </h1>
          <div className="w-24 h-1 bg-azure-600 mx-auto mb-12"></div>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-xl text-gray-700 mb-12 leading-relaxed"
          >
            Deine Daten wurden erfolgreich übermittelt. Hier kannst du den KI-Guide für Unternehmen herunterladen:
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="bg-white rounded-xl p-8 inline-block shadow-lg"
          >
            <h3 className="text-2xl font-bold text-black mb-4">
              KI-Guide für Unternehmen: Von der Vision zur Umsetzung
            </h3>
            <p className="text-gray-600 mb-6">
              Ein praktischer Leitfaden für die digitale Transformation mit KI
            </p>
            <a
              href="https://raw.githubusercontent.com/mike3011/Dateien/5917e89c8c58c7d7591c8eb7a89ff04a9aa3f8b6/KI_Guide_Unternehmen_Design_v2.pdf"
              target="_blank"
              rel="noopener noreferrer"
              download="KI-Guide-fuer-Unternehmen.pdf"
              className="inline-flex items-center bg-azure-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-azure-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <SafeIcon icon={FiDownload} className="text-xl mr-3" />
              PDF herunterladen
            </a>
            <p className="text-gray-600 mt-4 text-sm">
              Falls der Download nicht automatisch startet, klicke bitte auf den Button.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }}
            className="mt-12 text-center"
          >
            <p className="text-gray-600 mb-4">
              Du hast Fragen oder benötigst weitere Unterstützung?
            </p>
            <a
              href="https://cal.meetergo.com/mike-trepte/15-min-telefonat-kostenfrei"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-azure-600 hover:text-azure-700 font-semibold underline"
            >
              Jetzt kostenloses Beratungsgespräch buchen
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.9 }}
            className="mt-16 bg-azure-50 rounded-xl p-6"
          >
            <h4 className="text-xl font-semibold text-black mb-4">
              Was erwartet Sie im KI-Guide?
            </h4>
            <div className="grid md:grid-cols-2 gap-6 text-left">
              <div>
                <h5 className="font-semibold text-azure-700 mb-2">1. Vision & Mission</h5>
                <p className="text-sm text-gray-600">
                  Strategische Ausrichtung für Ihre digitale Transformation
                </p>
              </div>
              <div>
                <h5 className="font-semibold text-azure-700 mb-2">2. Praktische Strategie</h5>
                <p className="text-sm text-gray-600">
                  Balance zwischen Regulierung und Innovation
                </p>
              </div>
              <div>
                <h5 className="font-semibold text-azure-700 mb-2">3. Konkrete Umsetzung</h5>
                <p className="text-sm text-gray-600">
                  Checkliste für den Einstieg mit Quick Wins
                </p>
              </div>
              <div>
                <h5 className="font-semibold text-azure-700 mb-2">4. Kontinuierliche Reflexion</h5>
                <p className="text-sm text-gray-600">
                  Langfristige Erfolgskontrolle und Anpassung
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Danke;